export default __webpack_public_path__ + "locales/az/BackupCodesDialog.json?hash=55704e330e2663fe5651708b3ed6efcc";